import storage from 'libs/storage'

export default {
    state: {
        userInfo: ''
    },
    getters: {
        getUserInfo: state => {
            if (state.userInfo) {
                return state.userInfo
            } else {
                storage.get('userInfo').then(res=>{
                    state.userInfo = res
                });
            }
            return state.userInfo;
        }
    },
    mutations: {
        setUserInfo(state, userInfo) {
            storage.set('userInfo', userInfo);
            state.userInfo = userInfo
        },
        clearUserInfo(state){
            storage.remove('userInfo')
            state.userInfo=''
        }
    },
    actions: {
        getUserInfo({ commit}) {
            return new Promise((resolve, reject) => {
                try {
                    //直接用本地缓存 不请求数据
                    storage.get('userInfo').then((res)=>{
                        if(!res)  {
                            reject(res);
                            return ;
                        }
                        if(!!res.userInfo){
                            resolve(res)
                            commit('setUserInfo',res)
                            return ;
                        }

                    })
                } catch (error) {
                    reject(error);
                }
            });
        }
    }
}
